import { AxiosResponse } from 'axios';

import { http } from '@/api/http';
import { ApiVersion } from '@/config';

export interface FileToken {
  sasToken: string;
  expiresOn: string;
  folder: string;
}

export interface LiveTranscriptionSession {
  clientSecret: string;
  expiresAt: number;
}

export const StorageApi = {
  getSasTokens: (): Promise<AxiosResponse<FileToken[]>> => {
    return http.post(`api/${ApiVersion.V1}/storage/folders-sas-tokens`);
  },
  transcribeAudio: (data: FormData): Promise<AxiosResponse<any>> => {
    return http.post(`api/${ApiVersion.V1}/storage/transcribe`, data);
  },
  createLiveTranscriptionSession: (): Promise<
    AxiosResponse<LiveTranscriptionSession>
  > => {
    return http.post(`api/${ApiVersion.V1}/storage/transcribe/live/session`);
  },
};
